<div *ngIf="loader.isLoading" class="backdrop" fxLayoutAlign="center center">
    <mat-spinner></mat-spinner>
</div>
